// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"ZapNotAvailable_sectionWrapper__Z1Ou_","recreateZapButton":"ZapNotAvailable_recreateZapButton__FOS8a"};